var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-reset"},[_c('navbar'),(!_vm.$store.getters.getLoading)?_c('AuthCard',{attrs:{"page":"update"}}):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }